import { render, staticRenderFns } from "./VircosMeasures.vue?vue&type=template&id=193ddd51&scoped=true&"
import script from "./VircosMeasures.vue?vue&type=script&lang=js&"
export * from "./VircosMeasures.vue?vue&type=script&lang=js&"
import style0 from "./VircosMeasures.vue?vue&type=style&index=0&id=193ddd51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ddd51",
  null
  
)

export default component.exports